import { createTheme } from '@fluentui/styles';
import animations from './animations';
import * as siteVariables from './siteVariables';
import * as componentVariables from './componentVariables';
import * as componentStyles from './componentStyles';
import fontFaces from './fontFaces';
import staticStyles from './staticStyles';
var teamsTheme = createTheme({
  siteVariables: siteVariables,
  componentVariables: componentVariables,
  componentStyles: componentStyles,
  fontFaces: fontFaces,
  staticStyles: staticStyles,
  animations: animations
}, 'teams');
export default teamsTheme;
//# sourceMappingURL=index.js.map
